import {
  ChartBarIcon,
  HomeIcon,
  TrendingUpIcon as PortfolioIcon,
  LibraryIcon as PolygonTreasuryIcon,
} from '@heroicons/react/outline';
import { useChain, useSettings } from 'contexts';
import React from 'react';
import { useTranslation } from 'react-i18next';
import NavItem from './NavItem';

const NAV_ITEMS = [
  {
    path: '/',
    titleKey: 'home.title',
    icon: HomeIcon,
  },
  {
    path: '/stats',
    titleKey: 'chain_stats.title',
    icon: ChartBarIcon,
  },
  {
    path: '/portfolio',
    titleKey: 'portfolio.title',
    icon: PortfolioIcon,
  },
  {
    path: '/polygon-treasury',
    titleKey: 'polygon_treasury.title',
    icon: PolygonTreasuryIcon,
  },
  // {
  //   path: '/dapps',
  //   titleKey: 'dapps.title',
  //   icon: DappsIcon,
  // },
  // {
  //   path: '/resources',
  //   titleKey: 'resources.title',
  //   icon: ResourcesIcon,
  // },
];

const Sidebar = () => {
  const { t } = useTranslation();
  const { styleSlug } = useChain();
  const { isSidebarExpanded } = useSettings();
  return (
    <ul
      className={`${
        isSidebarExpanded ? 'flex' : 'hidden'
      } md:flex flex-col pt-5 space-y-5 bg-white dark:bg-gray-111 border-r-2 border-sand-light dark:border-gray-222 text-${styleSlug}-primary dark:text-${styleSlug}-light tracking-wider uppercase`}
    >
      {NAV_ITEMS.map(({ path, titleKey, icon }) => (
        <NavItem
          key={titleKey}
          icon={icon}
          to={path}
          showTitle={isSidebarExpanded}
          styleSlug={styleSlug}
        >
          {t(titleKey)}
        </NavItem>
      ))}
    </ul>
  );
};

export default Sidebar;
